import { render } from "./InjetoraDashboard.vue?vue&type=template&id=682a1c6a&scoped=true"
import script from "./InjetoraDashboard.vue?vue&type=script&lang=js"
export * from "./InjetoraDashboard.vue?vue&type=script&lang=js"

import "./InjetoraDashboard.vue?vue&type=style&index=0&id=682a1c6a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-682a1c6a"]])

export default __exports__